export const formatAbleitungsrohre = (val: string): string => {
  if (val.includes(' Prozent')) {
    return val.replace(' Prozent', '%').replace('Versicherungssumme', 'VS');
  }
  if (val.includes('EUR')) {
    return val.replaceAll('EUR', '€');
  }
  return val;
};
